import Icon from "components/Elements/Icon/Icon.tsx";
import { useCustomController } from "components/Reusable/Form/useCustomController.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { getEmailListFromString } from "../../../../../../helpers/getEmailLstFromString.js";
import React, { useEffect, useRef, useState } from "react";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import './SubUserMultipleInput.scss';

const keyCodeList = [188, 32, 9, 186, 13];
const mailReg =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const SubUserMultipleInput = (props) => {
  const { getTextByKey } = useContent();

  const [innerError, setInnerError] = useState();
  const [mailValue, setMailValue] = useState("");
  const hasError = false;
  const mailsList = props.mailsList;
  const setMailsList = props.setMailsList;
  const wasPaste = useRef(null);

  const handleRemoveMail = (mail) => {
    setMailsList((prevMails) => prevMails.filter((item) => item !== mail));
  };

  const handleChange = (e) => {
    setMailValue(e.target.value);
  };

  const handleScrollToBottomList = () => {
    const listContainer = document.querySelector(".added-mails-container");
    listContainer.scrollTop = listContainer.scrollHeight;
  };

  const handleAddToList = (value) => {
    if(mailsList.length >= props.UserAvailableSubUsersLicenses) { 
      setInnerError(getTextByKey("not-enough-licenses"))
      return;
    }

    if (mailReg.test(value)) {
      if (!mailsList.includes(value)) {
        setMailsList((prev) => [...prev, value]);
        setMailValue("");
        setTimeout(() => {
          handleScrollToBottomList();
        });
      } else {
        setInnerError(getTextByKey("this-email-exist-text"));
      }
    } else {
      setInnerError(getTextByKey("invalid-email-text"));
    }
  };

  const handleAddMail = (e) => {
    if (mailValue.length !== 0) {
      if (keyCodeList.includes(e.keyCode)) {
        e.preventDefault();
      }
      if (innerError) {
        setInnerError(false);
      }
      if (keyCodeList.includes(e.keyCode)) {

        if(mailsList.length >= props.UserAvailableSubUsersLicenses) { 
          setInnerError(getTextByKey("not-enough-licenses"))
          return;
        }

        if (mailReg.test(mailValue)) {
          if (!mailsList.includes(mailValue)) {
            setMailsList((prev) => [...prev, mailValue]);
            setMailValue("");
            setTimeout(() => {
              handleScrollToBottomList();
            });
          } else {
            setInnerError(getTextByKey("this-email-exist-text"));
          }
        } else {
          setInnerError(getTextByKey("invalid-email-text"));
        }
      }
    }
  };

  const pasteHandler = (e) => {
    wasPaste.current = true;
    const paste =
      mailValue + (e.clipboardData || window.clipboardData).getData("text");
    const { validEmailList } = getEmailListFromString(paste);
    if(validEmailList.length > props.UserAvailableSubUsersLicenses) { 
      setInnerError(getTextByKey("not-enough-licenses"))
      return;
    }
    validEmailList.forEach((mail, i) => {
      if (
        !mailsList.includes(mail)
      ) {
        setMailsList((prev) => [...prev, mail]);
        setMailValue("");
      } else {
        setInnerError(getTextByKey("this-email-exist-text"));
      }
    });
    setTimeout(() => {
      setMailValue("");
      handleScrollToBottomList();
    });
    setTimeout(() => {
      wasPaste.current = false;
    }, 1100);
  };

  const wasTypedTime = useRef(null);

  const debouncedAddToList = (value) => {
    setTimeout(() => {
      if (Date.now() - wasTypedTime.current > 1000 && !wasPaste.current) {
        handleAddToList(value);
      }
    }, 1000);
  };

  useEffect(() => {
    wasTypedTime.current = Date.now();
    if (mailReg.test(mailValue)) {
      debouncedAddToList(mailValue);
    }
  }, [mailValue]);

  return (
    <label className={hasError ? "invalid-input" : ""}>
      <div className="input-label">
        <div className="input-title-label">
          {getTextByKey("email-list")}{" "}
        </div>
        {mailsList.length > 0 ? (
          <div className="mail-counter">
            {mailsList.length}
            <Icon name="user" gray />
          </div>
        ) : null}
        {props.tooltipText && (
            <Tooltip
            end
            tooltipText={props.tooltipText}
            className={"mails-input-tooltip"}
            >
            <div className="tooltip-icon-container">
                <Icon name="question-circle" iconClass="tooltip-icon" />
            </div>
          </Tooltip>
        )}
      </div>
      <div className="mails-input-container">
        <div className="added-mails-container">
          {mailsList.map((mail) => {
            return (
              <div className="mail-item" key={mail}>
                <span>{mail}</span>
                <Icon name="x" gray onClick={() => handleRemoveMail(mail)} />
              </div>
            );
          })}
        </div>
        {innerError || props.errorMessage ? (
          <div className="inner-error-holder">{innerError || props.errorMessage}</div>
        ) : null}
        <input
          className="input-field"
          // name="ShareToEmailRecipientTitle"
          type="email"
          value={mailValue}
          onChange={handleChange}
          onPaste={pasteHandler}
          onKeyDown={handleAddMail}
          onBlur={(e) => handleAddMail({ blurEvent: true, target: e.target })}
          autoComplete="ShareToEmailRecipientTitle"
          placeholder={props.placeHolder}
        />
      </div>
    </label>
  );
};
